import React, { FC, useRef } from 'react';
import { TextStyle } from 'texts/texts';
import { TextWithStyle } from 'components/TextWithStyle';
import './HighlightPair.css';
import { motion, useInView } from "framer-motion";

interface TextPart {
  text: string;
  style: TextStyle;
}

interface HighlightPairProps {
  title: TextPart[];
  description: string;
  imgSrc: string;
  imgAlt: string;
  reverse?: boolean;
}

export const HighlightPair: FC<HighlightPairProps> = ({ title, description, imgSrc, imgAlt, reverse = false }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });

  return (
    <motion.div
          ref={ref}
          initial={{ y: 100, opacity: 0 }}
          animate={isInView ? { y: 0, opacity: 1 } : { opacity: 0, y: 100 }}
          transition={{ type: "spring", stiffness: 50 }}
        className={`highlight-pair ${reverse ? 'reverse' : ''}`}>
      <div className="highlight-text">
        <h3>
          {title.map((part, index) => (
            <TextWithStyle key={index} text={part.text} style={part.style} />
          ))}
        </h3>
        <p>{description}</p>
      </div>
      <img src={imgSrc} alt={imgAlt} />
    </motion.div>
  );
};